import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export default {
  IconComponent: ExpandMoreIcon
};
